exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.add-event-modal .selections .v-select {\n  margin: 0 0 1rem;\n}\n.add-event-modal .timestamps {\n  padding: 0.5rem 0;\n  margin: 1rem 0;\n}\n.add-event-modal .timestamps > .wrapper > div {\n    -ms-flex: 1 1 0px;\n        flex: 1 1 0;\n}\n.add-event-modal .date-input {\n  margin-right: 1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-72852c30","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/EventAdd.vue
// module id = 1336
// module chunks = 0